export default "__VITE_ASSET__6d0bb202__"